import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Dialog, {
  DialogActions,
  DialogContent,
  DialogTitle,
} from 'components/common/Dialog';

import { submit, isSubmitting } from 'redux-form';

import Button from 'components/common/Button';

import PrescribersLinkedForm from './PrescribersLinkedForm';

const styles = () => ({
  form: {
    padding: '25px 40px',
  },
  action: {
    '&:first-child': {
      position: 'absolute',
      left: 14,
      top: 8,
    },
  },
});

const PrescribersLinkedDialog = ({
  open,
  onClose,
  onCreateButtonClick,
  onSubmitSuccess,
  actions,
  form,
  submitting,
  formValues,
  initialValues,
  variant,
  classes,
  ...otherProps,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="sm"
  >
    <DialogTitle>
      <Typography
        variant="title"
        color="secondary"
        align="center"
      >
        {variant === 'sales' ? 'Link the Referral Source to Sales Rep' : 'Link the Prescriber with a Referral Source'}
      </Typography>
    </DialogTitle>
    <DialogContent>
      <PrescribersLinkedForm
        {...otherProps}
        form={form}
        variant={variant}
        className={classes.form}
        initialValues={initialValues}
        onSubmitSuccess={onSubmitSuccess} 
      />
    </DialogContent>
    <DialogActions
      classes={{
        action: classes.action,
      }}
    >
      <Button
        onClick={() => onCreateButtonClick({ variant })}
        color="primary"
        underline
      >
        {variant === 'sales' ? 'Add New Sales' : 'Add New Referral'}
      </Button>
      <Button
        onClick={onClose}
        variant="raised"
      >
        Cancel
      </Button>
      <Button
        onClick={() => {
          actions.submit('patientPrescribersLinked');
        }}
        variant="raised"
        color="primary"
        disabled={submitting}
      >
        Add
      </Button>
    </DialogActions>
  </Dialog>
);

PrescribersLinkedDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onCreateButtonClick: PropTypes.func,
  onSubmitSuccess: PropTypes.func,
  submitting: PropTypes.bool.isRequired,
  actions: PropTypes.shape({
    submit: PropTypes.func.isRequired,
  }).isRequired,
  form: PropTypes.string.isRequired,
  formValues: PropTypes.shape({
    'Primary Insurance ID': PropTypes.number,
  }),
  classes: PropTypes.shape({
    form: PropTypes.string.isRequired,
  }).isRequired,
};

PrescribersLinkedDialog.defaultProps = {
  open: false,
  onClose: () => {},
  onSubmitSuccess: () => {},
  onCreateButtonClick: () => {},
  formValues: {},
};

const mapStateToProps = store => ({
  submitting: isSubmitting('patientPrescribersLinked')(store),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ submit }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(PrescribersLinkedDialog),
);



// WEBPACK FOOTER //
// ./src/components/patient/PatientProfile/Prescribers/PrescribersLinkedDialog.js